module.exports = __webpack_public_path__ + "img/744.3d20a1ef.jpg";